import type { Filter } from '../types/QueryTypes';
function getNestedValue(obj: Record<string, unknown>, path: string): unknown {
  return obj[path];
}
function matchesFilter(row: Record<string, unknown>, filter: Filter): boolean {
  if (matchesFilterCondition(row, filter)) return true;
  return (filter.or ?? []).some(f => matchesFilter(row, f));
}
function matchesFilterCondition(row: Record<string, unknown>, filter: Filter): boolean {
  const {
    field,
    operator,
    value
  } = filter;
  const fieldValue = getNestedValue(row, field);
  switch (operator) {
    case '=':
      {
        if (fieldValue === null || fieldValue === undefined) return false;
        if (typeof fieldValue === 'string' && typeof value === 'string') {
          return fieldValue.toLowerCase() === value.toLowerCase();
        }
        return fieldValue === value;
      }
    case '!=':
      {
        if (fieldValue === null || fieldValue === undefined) return false;
        if (typeof fieldValue === 'string' && typeof value === 'string') {
          return fieldValue.toLowerCase() !== value.toLowerCase();
        }
        return fieldValue !== value;
      }
    case '<':
      {
        if (fieldValue === null || fieldValue === undefined) return false;
        return Number(fieldValue) < Number(value);
      }
    case '<=':
      {
        if (fieldValue === null || fieldValue === undefined) return false;
        return Number(fieldValue) <= Number(value);
      }
    case '>':
      {
        if (fieldValue === null || fieldValue === undefined) return false;
        return Number(fieldValue) > Number(value);
      }
    case '>=':
      {
        if (fieldValue === null || fieldValue === undefined) return false;
        return Number(fieldValue) >= Number(value);
      }
    case 'contains':
      {
        if (fieldValue === null || fieldValue === undefined) return false;
        const str = String(fieldValue).toLowerCase();
        const search = String(value).toLowerCase();
        return str.includes(search);
      }
    case 'startsWith':
      {
        if (fieldValue === null || fieldValue === undefined) return false;
        const str = String(fieldValue).toLowerCase();
        const search = String(value).toLowerCase();
        return str.startsWith(search);
      }
    case 'endsWith':
      {
        if (fieldValue === null || fieldValue === undefined) return false;
        const str = String(fieldValue).toLowerCase();
        const search = String(value).toLowerCase();
        return str.endsWith(search);
      }
    case 'in':
      {
        if (fieldValue === null || fieldValue === undefined) return false;
        if (!Array.isArray(value)) return false;
        return value.some(v => {
          if (typeof fieldValue === 'string' && typeof v === 'string') {
            return fieldValue.toLowerCase() === v.toLowerCase();
          }
          return fieldValue === v;
        });
      }
    case 'isNull':
      {
        return fieldValue === null || fieldValue === undefined;
      }
    default:
      return true;
  }
}
export function applyFilters(rows: Record<string, unknown>[], filters: Filter[]): Record<string, unknown>[] {
  if (!filters || filters.length === 0) return rows;
  return rows.filter(row => filters.every(f => matchesFilter(row, f)));
}